import { createSelector } from '@ngrx/store';

import { SCANNER_FEATURE_KEY } from '../constants';
import { selectScanState } from '../main-selector';

const selectScannerState = createSelector(
  selectScanState,
  (state) => state[SCANNER_FEATURE_KEY],
);

export const selectScannerStatus = createSelector(
  selectScannerState,
  (state) => state.status,
);

export const selectCurrentBarcode = createSelector(
  selectScannerState,
  (state) => state.currentBarcode,
);

export const selectLoadingProduct = createSelector(
  selectScannerState,
  (state) => state.loadingProduct,
);

export const selectScanTarget = createSelector(
  selectScannerState,
  (state) => state.target,
);

export const selectBarcodeProcessResults = createSelector(
  selectScannerState,
  (state) => state.barcodeReadingResults,
);
